import { FC, useRef, useState } from "react";
import { IconButton, TableCell, TableRow } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import useOnClickOutside from "../../../../../hooks/useOnClickOutside";
import { Status } from "../PermitTable.styles";
import { Dot } from "../../../../../styles/Shared.styles";
import { green, red } from "@mui/material/colors";
import MoreMenu from "../MoreMenu/MoreMenu";

interface Props {
  weaponNo: string;
  manufacturer: string;
  model: string;
  caliber: string;
  weaponType: string;
  onClickAddSubPermit: () => void;
  onClickEdit: () => void;
  onClickSeeDetails: () => void;
  isHome?: boolean;
}

const PermitTableRow: FC<Props> = ({
  weaponNo,
  manufacturer,
  model,
  caliber,
  weaponType,
  onClickAddSubPermit,
  onClickEdit,
  onClickSeeDetails,
  isHome,
}) => {
  const [showMore, setShowMore] = useState<boolean>(false);
  const ref: any = useRef();

  useOnClickOutside(ref, () => setShowMore(false));

  return (
    <TableRow
      sx={{
        "&:last-child td, &:last-child th": {
          border: 0,
        },
      }}
    >
      <TableCell component="th" scope="row">
        {weaponNo}
      </TableCell>
      <TableCell component="th" scope="row">
        {manufacturer} {model}
      </TableCell>
      <TableCell component="th" scope="row">
        {weaponType}
      </TableCell>
      <TableCell component="th" scope="row" />
      <TableCell component="th" scope="row">
        {caliber}
      </TableCell>
      <TableCell component="th" scope="row">
        {isHome ? (
          <Status>
            <Dot size={12} color={green[400]} /> hjemme
          </Status>
        ) : (
          <Status>
            <Dot size={12} color={red[400]} /> ude
          </Status>
        )}
      </TableCell>
      <TableCell align="right" component="th" scope="row">
        <div ref={ref}>
          <>
            <IconButton
              aria-label="see more permit options"
              onClick={() => setShowMore((prevState) => !prevState)}
            >
              <MoreVertIcon />
            </IconButton>
            {showMore && (
              <MoreMenu
                onClickAddSubPermit={onClickAddSubPermit}
                onClickEdit={onClickEdit}
                onClickSeeDetails={onClickSeeDetails}
              />
            )}
          </>
        </div>
      </TableCell>
    </TableRow>
  );
};

export default PermitTableRow;
